import { type ThemeMode } from '@knack/asterisk-react';

export function isPreviewModeDark(mode: ThemeMode) {
  if (mode === 'system') {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const isSystemDark = media.matches;
    return isSystemDark;
  }
  return mode === 'dark';
}
